import React from 'react';
import PeopleSection from '../Components/PeopleSection';
import Snow from '../Components/Snow'

const People: React.FC = () => {
  return (
    <div>
      {/* <Snow/> */}
      <PeopleSection/>
    </div>
  );
};

export default People;